import { Injectable } from '@angular/core';
import { inject } from '@angular/core/testing';
import { AngularFirestore } from '@angular/fire/firestore';
import { Subject, Observable } from 'rxjs';
import { Link } from '../models/link.model';
import { Book } from '../models/book.model';
import { WordRefModel } from '../models/word-ref.model';
import { Word } from '../models/word.model';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  private subject = new Subject<any>();

  constructor(private firestore: AngularFirestore) { }

  sendClickEvent() {
    this.subject.next();
  }
  getClickEvent(): Observable<any> {
    return this.subject.asObservable();
  }

  getLinks(): Promise<Link[]> {
    let promise: Promise<Link[]> = new Promise((resolve, reject) => {
      const query: Observable<any> = this.firestore.collection('pv-links', ref => ref.where('status', '==', 1)).get()
      query.subscribe(queriedItems => {
        var links = queriedItems.docs.map(function (doc) {
          var link: Link = new Link()
          link.id = doc.id
          Object.assign(link, doc.data())
          return link
        })
        resolve(links)
      })
    });
    return promise;
  }

  getBooks(): Promise<Book[]> {
    let promise: Promise<Book[]> = new Promise((resolve, reject) => {
      const query: Observable<any> = this.firestore.collection('pv-books', ref => ref.where('status', '==', 1)).get()
      query.subscribe(queriedItems => {
        var links = queriedItems.docs.map(function (doc) {
          var book: Book = new Book()
          book.id = doc.id
          Object.assign(book, doc.data())
          return book
        })
        resolve(links)
      })
    });
    return promise;
  }

  searchWords(text: string): Promise<WordRefModel[]> {
    let promise: Promise<WordRefModel[]> = new Promise((resolve, reject) => {
      if (text == "") {
        resolve([]);
      }
      const query: Observable<any> = this.firestore.collection('pv-words-ref', ref => ref.where('lowercasedText', '>=', text).where('lowercasedText', '<=', text + '\uf8ff').limit(10)).get()
      query.subscribe(queriedItems => {
        var words: WordRefModel[] = queriedItems.docs.map(function (doc) {
          var word: WordRefModel = new WordRefModel()
          word.id = doc.id;
          Object.assign(word, doc.data())
          return word
        })
        resolve(words)
      })
    });
    return promise;
  }

  getWord(id: string): Promise<Word> {
    let promise: Promise<any> = new Promise((resolve, reject) => {
      const query: Observable<any> = this.firestore.collection('pv-words').doc(id).get()
      query.subscribe(queriedItem => {
        if (queriedItem.data()) {
          const doc = queriedItem.data();
          const word: Word = new Word()
          word.id = queriedItem.id;
          Object.assign(word, doc)
          resolve(word);
        } else {
          reject();
        }
      })
    });
    return promise;
  }

  getBanner(id:string): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      this.firestore.collection('banners').doc(id).get().subscribe(queriedItem => {
        const result = queriedItem.data();
        resolve(result);
      })
    });
    return promise
  }

}




